import { Icon, LoadMore } from '@fv/client-components'
import type { ListShipment } from '@fv/client-types'

import { supportMessage } from '@/constants'
import { useSearchShipments } from '@/features/shipment-list/hooks/useSearchShipments'
import {
  useSearchListParams,
  useSetActiveLoadId,
} from '@/features/shipment-list/hooks/useShipmentListParams'
import { ShipmentCard } from '@/features/shipment-list/ShipmentCard'
import { useQueryParam } from '@/hooks/settings'

import InfoBox from './InfoBox'
import LoadDetailPanel from './list/LoadDetailPanel'

const SearchResults = () => {
  const searchText = useQueryParam('text')
  const shipmentsQuery = useSearchShipments(searchText)
  const shipmentList: ListShipment[] = shipmentsQuery.data ?? []
  const { activeLoadId } = useSearchListParams(shipmentList)
  const setActiveLoad = useSetActiveLoadId()

  return (
    <div className="shipper-page-fill shipper-grid-rows-single-fill grid overflow-hidden bg-[#f2f2f2] grid-cols-[19rem_1fr_30.5rem]">
      <div className="b1400:col-start-1 b1400:row-start-1">
        <div className="relative flex h-full flex-col border-r border-fv-blue-150 bg-fv-blue-50 px-6 pt-6 b1450:border-b b1450:border-gray-300 b1450:px-8 b1450:py-6">
          <div className="border-none p-0">
            <p className="mb-0 flex flex-nowrap items-start">
              <Icon
                icon="search"
                className="text-fv-gray-dark"
                transform="down-2.5"
              />
              <span>Search results for "{searchText}"</span>
            </p>
          </div>
        </div>
      </div>

      <div
        className="py-8 px-6 bg-fv-gray-100 overflow-auto b1400:relative b1400:z-10 b1400:col-start-1 b1400:col-span-2 b1400:row-start-1"
        id="shipmentList"
      >
        {shipmentsQuery.isError && (
          <InfoBox icon="triangle">
            Unable to load shipments, {supportMessage}
          </InfoBox>
        )}

        {shipmentsQuery.isLoading && shipmentsQuery.isFetching ? (
          <InfoBox icon="spinner">Loading...</InfoBox>
        ) : (
          <>
            {shipmentList.map(load => (
              <ShipmentCard
                isActive={load.loadId === activeLoadId}
                key={load.loadId}
                onClick={() => setActiveLoad(load.loadId)}
                shipment={load}
              />
            ))}

            {!shipmentList.length && <InfoBox>No shipments found.</InfoBox>}
          </>
        )}

        <LoadMore
          className="mt-4"
          fetchNextPage={shipmentsQuery.fetchNextPage}
          hasNextPage={shipmentsQuery.hasNextPage}
          isLoading={shipmentsQuery.isFetchingNextPage}
        />
      </div>

      <LoadDetailPanel key={activeLoadId} loadId={activeLoadId} />
    </div>
  )
}

export default SearchResults
